import axios from 'axios'
import Api from '@/axios/api'

export default {
  async fetchPageData ({ commit }, { params, campaignsSignal, tagsSignal } = {}) {
    try {
      const [campaignsResponse, tagsResponse] = await Promise.all([
        Api.get('/campaigns', {
          params: { ...params, paginate: true, page: 1 },
          signal: campaignsSignal,
        }),
        Api.get('/campaigns/tags', {
          params: { for_customer: true },
          signal: tagsSignal,
        }),
      ])

      const permissions = campaignsResponse.permissions ?? []

      commit('setCampaigns', campaignsResponse.data)
      commit('setMeta', campaignsResponse.meta)
      commit('setLinks', campaignsResponse.links)
      commit('setPermissions', permissions)

      return {
        permissions,
        totalSendsFailed: campaignsResponse.total_sends_failed ?? 0,
        totalEgiftSendsFailed: campaignsResponse.total_egift_sends_failed ?? 0,
        tags: tagsResponse.data,
      }
    } catch (error) {
      if (!axios.isCancel(error)) {
        console.error(error)
      }
      throw error
    }
  },

  // Cached, lightweight permissions check used by the create-campaign route guard
  // so it doesn't have to load the full campaigns list just to read `permissions`.
  async fetchPermissions ({ commit, state }) {
    if (state.permissions !== null) {
      return state.permissions
    }

    try {
      const response = await Api.get('/campaigns', { params: { paginate: true, page: 1, per_page: 1 } })
      const permissions = response.permissions ?? []

      commit('setPermissions', permissions)

      return permissions
    } catch (error) {
      if (!axios.isCancel(error)) {
        console.error(error)
      }

      return []
    }
  },

  async loadMoreCampaigns ({ commit, state }, { params, signal } = {}) {
    commit('setLoadingPage', true)
    const nextPage = state.meta.currentPage + 1
    try {
      const response = await Api.get('/campaigns', {
        params: { ...params, paginate: true, page: nextPage },
        signal,
      })
      commit('addCampaigns', response.data)
      commit('setMeta', response.meta)
      commit('setLinks', response.links)
    } catch (error) {
      if (!axios.isCancel(error)) {
        console.error(error)
      }
    } finally {
      commit('setLoadingPage', false)
    }
  },
}
